import { render, staticRenderFns } from "./ParamsEdit.vue?vue&type=template&id=f87150b6&scoped=true&"
import script from "./ParamsEdit.vue?vue&type=script&lang=js&"
export * from "./ParamsEdit.vue?vue&type=script&lang=js&"
import style0 from "./ParamsEdit.vue?vue&type=style&index=0&id=f87150b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87150b6",
  null
  
)

export default component.exports